import { Box, Checkbox, ClickAwayListener, FormControlLabel, Grid, IconButton, InputAdornment, Popper, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import React, { createContext, useContext, useEffect, useReducer, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/icon_calender.svg";
import Controls from '../../../components/controls/Controls';
import { useMeasureListContext } from '../../../contexts/MeasureListContext';
import Loader from '../../../pages/Loader';
import { generateCustomDateRange } from "../../../utils/Reusables";
import getDataFromCube from '../../../utils/getCubeData';

function ReportFilterMenu({
  report,
  icon
}) {
  const { filterState, updateFilter } = useReportFilters();
  const filterIconButtonRef = useRef();
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(null);
  //console.log(tabIndex,filterState.filters)
  useEffect(() => {
    //console.log('useEffect')
    let filterList = filterState.filters.map(obj => {
      if (!obj.hasOwnProperty('hidden')) {
        obj.hidden = false
      }
      return obj
    })
    //if (filterState.filters?.length === 0 || tabIndex !== null) return;
    if (tabIndex !== null) {
      const filterObj = filterList.find((filter) => filter?.isCascadedHidden === false && filter?.hidden === false && filter.filterIndex === tabIndex)
      if (filterObj) {
        return
      } else {
        const filterIndex = filterList.find((filter) => filter?.isCascadedHidden === false && filter?.hidden === false)?.filterIndex
        if ((filterIndex !== null || filterIndex !== undefined) && tabIndex !== filterIndex) {
          setTabIndex(filterIndex !== null || filterIndex !== undefined ? filterIndex : null)
        }
      }
    } else {
      const filterIndex = filterList.find((filter) => filter?.isCascadedHidden === false && filter?.hidden === false)?.filterIndex
      if ((filterIndex !== null || filterIndex !== undefined) && tabIndex !== filterIndex) {
        setTabIndex(filterIndex !== null || filterIndex !== undefined ? filterIndex : null)
      }
    }
  }, [filterState.filters])

  if (report?.reportFilters.length === 0) return null;


  function onfilterIconClick() {
    setIsFilterMenuOpen((prev) => !prev);
  }

  function onFilterMenuClose() {
    setIsFilterMenuOpen(false);
  }
  return (
    <>
      {
        filterState.filters.length > 0
          ? (
            <IconButton
              disabled={false}
              className="form-icon-btn"
              size="small"
              onClick={onfilterIconClick}
              ref={filterIconButtonRef}
            >
              {icon}
            </IconButton>
          ) : null
      }
      {
        isFilterMenuOpen
          ? (
            <ClickAwayListener onClickAway={onFilterMenuClose}>
              <Popper
                id="long-menu"
                open={isFilterMenuOpen}
                anchorEl={filterIconButtonRef.current}
                onClose={onFilterMenuClose}
                placement='bottom-end'
                popperOptions={{ positionFixed: true }}
                sx={{
                  minWidth: 100,
                  minHeight: '400px',
                  height: 'auto',
                  overflow: 'visible',
                  boxShadow: '0 0 4px #00000029',
                  borderRadius: '8px',
                  zIndex: 9,
                  backgroundColor: '#F1F1F1',
                }}
              >
                <Box sx={{ width: '100%', minHeight: '400px', height: 'auto', overflow: 'visible', display: 'flex' }}>
                  <Box
                    sx={{
                      minWidth: '135px',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        overflow: 'auto',
                        minWidth: '135px',
                        backgroundColor: '#f1f1f1',
                      }}
                    >
                      {
                        filterState.filters.map((filter, index) => {
                          //console.log(filter)
                          if (filter?.isCascadedHidden) return null;
                          const isSelected = tabIndex === filter.filterIndex;
                          return (
                            <Box
                              key={`filter-item-tab-${filter.member}-${filter.filterIndex}`}
                              sx={{
                                height: '48px',
                                backgroundColor: isSelected ? '#fff' : '#f1f1f1',
                                borderLeft: isSelected ? '3px solid #f45e29' : '3px solid #f1f1f1',
                                color: isSelected ? '#f45e29' : '#202124',
                                borderRight: 0,
                                fontSize: '14px',
                                fontWeight: isSelected ? 600 : 400,
                                textAlign: 'left',
                                padding: '0.7rem',
                                cursor: 'pointer'
                              }}
                              onClick={() => setTabIndex(filter.filterIndex)}
                            >
                              {filter?.displayName ?? filter?.member?.split('.')?.[1]}
                            </Box>
                          )
                        })
                      }
                    </Box>
                  </Box>
                  {
                    filterState.filters.map((filter, index) => {
                      return (
                        <CustomTabPanel
                          key={`report-filter-tabpanel-${filter.member}-${filter.filterIndex}`}
                          index={filter.filterIndex}
                          value={tabIndex}
                        >
                          <FilterItem filter={filter} filterIndex={index} onFilterMenuClose={onFilterMenuClose} />
                        </CustomTabPanel>
                      )
                    })
                  }
                </Box>
              </Popper>
            </ClickAwayListener>
          ) : null
      }
    </>
  )
}

function CustomTabPanel({ children, value, index }) {
  if (value != index) return null;
  return children;
}

function FilterItem({ filter,filterIndex, onFilterMenuClose }) {
  const { updateFilter } = useReportFilters();
  return (
    <Box
      sx={{
        maxWidth: '250px',
        width: 'calc(100vw - 135px)',
        paddingY: '0.25rem',
        height: 'inherit',
        backgroundColor: 'white',
        overflow: 'visible'
      }}
    >
      {
        (filter.operator === "beforeDate" || filter.operator === "afterDate")
          ? (
            <Grid container spacing={2} >
              <Grid xs={10} md={10} item >
                <Typography className="report-form-label text-small" variant="subtitle2" >Date</Typography>
                <DatePicker
                  autoComplete='off'
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy HH:mm:ss"
                  className="report_form_ui_input_date"
                  selected={filter?.values[0] && moment(filter?.values[0]).toDate()}
                  onChange={(date) => updateFilter({ filterIndex: filter.filterIndex, values: [date] })}
                />
              </Grid>
            </Grid>
          )
          : null
      }
      {
        filter.operator === ('inDateRange' || 'notInDateRange')
          ? (
            <DateRange filter={filter} onFilterMenuClose={onFilterMenuClose} />
          ) : null
      }
      {
        ['gt', 'lt', 'gte', 'lte', 'equals', 'notEquals','contains','notContains'].indexOf(filter.operator) > -1 && filter.listType === 'inputValue' ? (
          <InputValue filter={filter} onFilterMenuClose={onFilterMenuClose} />
        ) : null
      }
      {
        filter.operator === 'equals' && filter.listType != 'inputValue'
          ? (
            <FilterList filter={filter} onFilterMenuClose={onFilterMenuClose} />
          ) : null
      }
      
    </Box>
  )
}

function InputValue({filter,onFilterMenuClose}){  
  const {updateFilter, clearFilter, applyFilter } = useReportFilters();
  //console.log(filter,filterState)
  const onInputChange = (e) => {
    if(e.target.value){
      updateFilter({ filterIndex: filter.filterIndex, values: [e.target.value] })
    }else{
      updateFilter({ filterIndex: filter.filterIndex, values: [] })
    }    
  }

  async function clearAllFilters() {
    await clearFilter(filter.filterIndex);
  }

  async function applyAllFilter() {
    await applyFilter(filter);
  }

  return (<Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      justifyContent: 'flex-start',
    }}
  >
    <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
          justifyContent: 'flex-start',
        }}
      >
    <TextField
      size="medium"
      type={['gt','gte','lt','lte'].indexOf(filter.operator) > -1 ? 'number':'search'}
      placeholder={['equals','contains'].indexOf(filter.operator) > -1 ? 'Search' : ['gt','gte'].indexOf(filter.operator) > -1? 'Greater Than' : ['lt','lte'].indexOf(filter.operator) > -1? 'Less Than' : ['notEquals','notContains'].indexOf(filter.operator) > -1? 'Not Equals' : 'Search 123'}
      onChange={onInputChange}
      className="cm_rprt_setting_content form_input_outline dasboard-filters-view-dropdown-search"
      style={{ borderBottom: '0px' }}
      value={filter.values[0] ?? ''}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <InputSearchIcon className="input_search_icon" />
          </InputAdornment>
        ),
      }}
    />
    </Box>
    <Box
      sx={{
        zIndex: '1',
        display: 'flex',
        justifyContent: 'space-around',
        padding: '0.5rem 0',
        alignItems: 'end'
      }}
    >
      <Controls.Button className="report_form_ui_btn cancel cancel2" disabled={!filter?.values?.length} color="secondary" text="Clear All" onClick={clearAllFilters} />
      <Controls.Button className="report_form_ui_btn submit" type="submit" text="Apply" onClick={applyAllFilter} />
    </Box>
  </Box>)
}

function FilterList({ filter, onFilterMenuClose }) {
  //console.log(filter)
  const { updateFilter, clearFilter, applyFilter } = useReportFilters();
  const [optionsState] = useInitialOptionState(filter);
  const [searchOptionsState, debouncedFetchFilterOptions] = useSearchOptionsState({ filter, optionsState });
  function onFilterRadioChange(e) {
    updateFilter({ filterIndex: filter.filterIndex, values: [e.target.value] })
  }
  function onFilterCheckboxChange(e) {
    const values = [...filter.values];
    if (e.target.checked) {
      values.push(e.target.value);
    } else {
      const index = values.indexOf(e.target.value);
      if (index > -1) {
        values.splice(index, 1);
      }
    }
    updateFilter({ filterIndex: filter.filterIndex, values })
  }
  function onSelectAllCheckboxChange(e) {
    if (e.target.checked) {
      updateFilter({ filterIndex: filter.filterIndex, values: searchOptionsState.options.length ? searchOptionsState.options : optionsState.options })
    } else {
      updateFilter({ filterIndex: filter.filterIndex, values: [] })
    }
  }
  async function clearAllFilters() {
    await clearFilter(filter.filterIndex);
    // onFilterMenuClose()
  }

  async function applyAllFilter() {
    //console.log(filter)
    await applyFilter(filter);
    // onFilterMenuClose()
  }
  //console.log('Filter List')
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        justifyContent: 'space-between',
        maxHeight: '450px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
          justifyContent: 'flex-start',
        }}
      >
        {(optionsState.loading || searchOptionsState.loading) ? <Loader /> : null}
        <Box sx={{ paddingX: '12px' }}>
          <TextField
            size="medium"
            type="search"
            placeholder="Search..."
            onChange={debouncedFetchFilterOptions}
            className="cm_rprt_setting_content form_input_outline dasboard-filters-view-dropdown-search"
            style={{ borderBottom: '0px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <InputSearchIcon className="input_search_icon" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {
          filter.listType !== 'dropdown'
            ? (
              <Box sx={{ paddingX: '15px' }}>
                <FormControlLabel
                  key={`filter-option-select-all`}
                  className='text-plain menu-item'
                  label={'Select All'}
                  style={{
                    fontSize: '14px !important',
                    lineHeight: '19px !important',
                    width: '100%'
                  }}

                  control={
                    <Checkbox
                      className="form_icon"
                      size="small"
                      checked={filter.values.length && !optionsState.loading ? filter.values.length === optionsState.options.length : (searchOptionsState.seachText !== '' && !searchOptionsState.loading && filter.values.length === searchOptionsState.options.length)}
                      value={'Select All'}
                      onChange={onSelectAllCheckboxChange}
                    />
                  }
                />
                <Box sx={{ borderBottom: '1px solid #dedede' }}></Box>
              </Box>
            ) : null
        }
        {
          (optionsState.options.length > 0 || searchOptionsState.options.length > 0)
            ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                  overflow: 'auto',
                  paddingX: '15px'
                }}
              >
                {
                  (searchOptionsState.options.length > 0 ? searchOptionsState.options : optionsState.options).map((option, index) => {
                    return (
                      <FormControlLabel
                        key={`filter-option-${filter.member}-${index}`}
                        className="text-plain menu-item"
                        label={option}
                        sx={{ marginRight: '0px' }}
                        control={
                          filter.listType === 'dropdown'
                            ? (
                              <Radio
                                className="form_checkbox"
                                size="small"
                                checked={filter.values.includes(option)}
                                value={option}
                                onChange={onFilterRadioChange}
                              />
                            )
                            : (
                              <Checkbox
                                className="form_icon"
                                size="small"
                                checked={filter.values.includes(option)}
                                value={option}
                                onChange={onFilterCheckboxChange}
                              />
                            )
                        }
                      />
                    )
                  })
                }
              </Box>
            ) : null
        }
      </Box>
      <Box
        sx={{
          zIndex: '1',
          display: 'flex',
          justifyContent: 'space-around',
          padding: '0.5rem 0',
          alignItems: 'end'
        }}
      >
        <Controls.Button className="report_form_ui_btn cancel cancel2" disabled={!filter.values.length} color="secondary" text="Clear All" onClick={clearAllFilters} />
        <Controls.Button className="report_form_ui_btn submit" type="submit" text="Apply" onClick={applyAllFilter} />
      </Box>
    </Box>
  )
}

function DateRange({ filter, onFilterMenuClose }) {
  // console.log('999 Render', filter)
  const {filterState, updateFilter, applyFilter, clearFilter } = useReportFilters();
  const [timePeriodValue, setTimePeriodValue] = useState(filter.dateFilterProps?.selectedTimePeriod ?? '');
  //console.log(filterState,filter.filterIndex) 
  const filterValues = filterState.filters[filter.filterIndex].values
  const [dateRangeStartDate, setDateRangeStartDate] = useState(
    (filterValues && filterValues[0]) ? moment(filterValues[0]).toDate() : ''
  );
  const [dateRangeEndDate, setDateRangeEndDate] = useState(
    (filterValues && filterValues[1]) ? moment(filterValues[1]).toDate() : ''
  );

  console.log(filterValues)
  const applyAllFilter = async () => {
    onDateRangeChange({ startDate: dateRangeStartDate, endDate: dateRangeEndDate });
    await applyFilter(filter);
    // onFilterMenuClose()
  }

  function onDateRangeChange({ startDate, endDate }) {

    const values = filter.values;
    //console.log(filterState,filterValues)
    const timeFlag = filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime" ? true:false
    //console.log(values)
    if (startDate) {
      if (moment(startDate).isValid() === false) {
        toast.error('Please select valid start date');
        return;
      }
      if (values[1] && moment(startDate).isAfter(moment(values[1]))) {
        toast.error('Start date should be less than end date');
        return;
      }
      values[0] = moment(startDate).format('YYYY/MM/DD HH:mm:ss');
    }
    if (endDate) {
      if (moment(endDate).isValid() === false) {
        toast.error('Please select valid end date');
        return;
      }
      if (values[0] && moment(endDate).isBefore(moment(values[0]))) {
        toast.error('End date should be greater than start date');
        return;
      }
      values[1] = endDate && !timeFlag ? moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'): moment(endDate).format('YYYY/MM/DD HH:mm:ss')
    }
    filter.values = values;
    updateFilter({ filterIndex: filter.filterIndex, filter })
  }
  if (filter.dateFilterProps?.dateSelectType === "DATE_RANGE") {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            paddingX: '15px'
          }}
        >
          <Grid sx={{ height: 'fit-content' }} container spacing={2} className='report-dash-report-filters-picker' >
            <Grid xs={10} md={10} item >
              <Typography className="report-form-label text-small" variant="subtitle2" >Start Date</Typography>
              <DatePicker
                autoComplete='off'
                dropdownMode="select"
                showYearDropdown={true}
                showMonthDropdown={true}
                // dateFormat="dd/MM/yyyy HH:mm:ss"
                dateFormat="dd/MM/yyyy"
                className="report_form_ui_input_date"
                minDate={new Date("01-01-2021 00:00:00")}
                maxDate={new Date()}
                //selected={filterValues && filterValues.length > 0 && filterValues[0] && moment(filterValues[0]).toDate()}
                selected={dateRangeStartDate}
                showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                onChange={(date) => {
                  setDateRangeStartDate(date);
                  // onDateRangeChange({ startDate: date });
                }}
                popperPlacement="bottom-left"
                popperModifiers={[
                  {
                    name: "offset",
                    options: {
                      offset: [0, 5],
                    },
                  },
                  {
                    name: "preventOverflow",
                    options: {
                      rootBoundary: "viewport",
                      tether: false,
                      altAxis: true,
                    },
                  },
                ]}
              />
            </Grid>
            <Grid xs={10} md={10} item >
              <Typography className="report-form-label text-small" variant="subtitle2" >End Date</Typography>
              <DatePicker
                autoComplete='off'
                maxDate={new Date()}
                dropdownMode="select"
                showYearDropdown={true}
                showMonthDropdown={true}
                // dateFormat="dd/MM/yyyy HH:mm:ss"
                dateFormat="dd/MM/yyyy"
                className="report_form_ui_input_date"
                minDate={new Date(filterValues[0])}
                // selected={filterValues[1] && moment(filterValues[1]).toDate()}
                selected={dateRangeEndDate}
                onChange={(date) => {
                  setDateRangeEndDate(date);
                  // onDateRangeChange({ endDate: date });
                }}
                showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                popperPlacement="bottom-left"
                popperModifiers={[
                  {
                    name: "offset",
                    options: {
                      offset: [0, 5],
                    },
                  },
                  {
                    name: "preventOverflow",
                    options: {
                      rootBoundary: "viewport",
                      tether: false,
                      altAxis: true,
                    },
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          className="test"
          sx={{
            zIndex: '1',
            display: 'flex',
            justifyContent: 'space-around',
            padding: '0.5rem 0',
          }}
        >
          <Controls.Button className="report_form_ui_btn cancel cancel2" color="secondary" text="Clear All" 
            onClick={() => {
              setDateRangeStartDate('');
              setDateRangeEndDate('');
              clearFilter(filter.filterIndex)
            }} 
            // disabled={!filter?.values?.length && !timePeriodValue} 
            disabled={(dateRangeStartDate == null || dateRangeEndDate == null)} 
          />
          <Controls.Button className="report_form_ui_btn submit" type="submit" text="Apply" 
            onClick={applyAllFilter} 
          />
        </Box>
      </Box>
    )
  }

  function onTimePeriodChange(event) {
    //console.log(filter)
    if (event.target.value === 'Custom') {
      setTimePeriodValue(event.target.value);
      filter.values = [];
      filter.dateFilterProps.selectedTimePeriod = event.target.value;
      updateFilter({ filterIndex: filter.filterIndex, filter })
      return
    }
    setTimePeriodValue(event.target.value);
    const { startDate, endDate } = generateCustomDateRange(event.target.value)
    filter.values = [startDate, endDate];
    filter.dateFilterProps.selectedTimePeriod = event.target.value;
    updateFilter({ filterIndex: filter.filterIndex, filter })
  }

  function onCustomTimePeriodChange({ startDate, endDate }) {
    const values = filter.values;
    if (startDate) {
      if (moment(startDate).isValid() === false) {
        toast.error('Please select valid start date');
        return;
      }
      if (values[1] && moment(startDate).isAfter(moment(values[1]))) {
        toast.error('Start date should be less than end date');
        return;
      }
      values[0] = moment(startDate).format('YYYY/MM/DD HH:mm:ss');
    }
    if (endDate) {
      if (moment(endDate).isValid() === false) {
        toast.error('Please select valid end date');
        return;
      }
      if (values[0] && moment(endDate).isBefore(moment(values[0]))) {
        toast.error('End date should be greater than start date');
        return;
      }
      let date = moment(endDate);
      if (date.hour() !== 23) {
        date = date.hour(23).minute(59).second(59);
      }
      values[1] = date.format('YYYY/MM/DD HH:mm:ss');
    }
    filter.values = values;
    updateFilter({ filterIndex: filter.filterIndex, filter })
  }

  async function onClearFilter() {
    setTimePeriodValue('')
    await clearFilter(filter.filterIndex);
    // onFilterMenuClose()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        width: '100%'
      }}
    >
      <Box sx={{ display: 'flex', flexGrow: '1', paddingX: '15px', overflow: 'visible', zIndex: '9999', maxHeight: 'calc(100% - 60px)' }}>
        <Grid className='filters-datefilter-group' sx={{ height: '100%', overflow: 'visible', width: '100%' }}>
          <RadioGroup
            name="controlled-radio-buttons-group"
          >
            {
              filter.dateFilterProps?.timePeriod?.map((timePeriod, index) => {
                return (
                  <FormControlLabel
                    key={`time-period-radio${index}`}
                    title={timePeriod}
                    className="text-plain menu-item"
                    label={timePeriod}
                    sx={{ marginRight: '0px' }}
                    control={
                      <Radio
                        className="form_checkbox"
                        size="small"
                        checked={filter.dateFilterProps?.selectedTimePeriod === timePeriod}
                        value={timePeriod}
                        onChange={onTimePeriodChange}
                      />
                    }
                  />
                )
              })
            }
            {
              filter.dateFilterProps && timePeriodValue === 'Custom' ? (
                <Box className="filters-dropdown-item-content" sx={{ p: '0.5rem 0 !important' }}>
                  <Grid container spacing={2} >
                    <Grid xs={12} md={12} item >
                      <Typography className="report-form-label" variant="subtitle2" >Start Date</Typography>
                      <DatePicker
                        autoComplete='off'
                        maxDate={new Date()}
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown={true}
                        showMonthDropdown={true}
                        minDate={new Date("01-01-2021 00:00:00")}
                        className="report_form_ui_input_date er-input-filter"
                        onChange={(date) => onCustomTimePeriodChange({ startDate: date })}
                        selected={filter?.values[0] && moment(filter?.values[0]).toDate()}
                        customInput={
                          <TextField className={`report_form_ui_input_date er-input-filter ${filter?.values[0] ? `has-value` : ``}`}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <CalendarIcon />
                                </InputAdornment>
                              ),
                            }} />
                        }
                        popperModifiers={[
                          {
                            name: "offset",
                            options: {
                              offset: [0, 5],
                            },
                          },
                          {
                            name: "preventOverflow",
                            options: {
                              rootBoundary: "viewport",
                              tether: false,
                              altAxis: true,
                            },
                          },
                        ]}
                      />
                    </Grid>
                    <Grid xs={12} md={12} item >
                      <Typography className="report-form-label" variant="subtitle2" >End Date</Typography>
                      <DatePicker
                        autoComplete='off'
                        dropdownMode="select"
                        maxDate={new Date()}
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown={true}
                        showMonthDropdown={true}
                        minDate={new Date(filter?.values[0])}
                        className="report_form_ui_input_date er-input-filter"
                        selected={filter?.values[1] && moment(filter?.values[1]).toDate()}
                        onChange={(date) => onCustomTimePeriodChange({ endDate: date })}
                        showTimeSelect={(filter?.dateFilterProps && filter?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                        customInput={
                          <TextField className={`report_form_ui_input_date er-input-filter ` + (filter?.values[1] ? `has-value` : ``)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <CalendarIcon />
                                </InputAdornment>
                              ),
                            }} />
                        }
                        popperModifiers={[
                          {
                            name: "offset",
                            options: {
                              offset: [0, 5],
                            },
                          },
                          {
                            name: "preventOverflow",
                            options: {
                              rootBoundary: "viewport",
                              tether: false,
                              altAxis: true,
                            },
                          },
                        ]}
                      />
                    </Grid>
                  </Grid>
                </Box>
              ) : null
            }
          </RadioGroup>
        </Grid>
      </Box>
      <Box
        sx={{
          zIndex: '1',
          display: 'flex',
          justifyContent: 'space-around',
          padding: '0.5rem 0',
        }}
      >
        <Controls.Button className="report_form_ui_btn cancel cancel2" disabled={!filter?.values.length > 0} color="secondary" text="Clear All" onClick={onClearFilter} />
        <Controls.Button className="report_form_ui_btn submit" type="submit" text="Apply" onClick={applyAllFilter} />
      </Box>
    </Box>
  )
}

function useInitialOptionState(filter) {
  const [optionsState, setOptionsState] = useState({
    options: [],
    loading: false,
    error: null
  });
  const { filterState } = useReportFilters();
  useEffect(() => {
    if (!filter?.isCascadedHidden && optionsState.options.length === 0 && filter.listType) {
      fetchInitalOptionsFromCube()
    }
  }, [filter?.isCascadedHidden]);

  async function fetchInitalOptionsFromCube() {
    setOptionsState((state) => ({ ...state, loading: true }))
    try {
      // relevant values case handle
      if (filter.specificValue) {
        setOptionsState((state) => ({ ...state, options: filter.valuesList }))
        return
      }
      if (filter.member && filter.dataSetType) {
        let fetchedData = null;
        let filters = filterState?.filters?.filter(_filter => _filter?.member === filter?.relevantTo);
        filters = filters?.map(_filter => {
          return {
            member: _filter?.member,
            operator: 'equals',
            values: _filter?.values
          }
        });
        if (filter?.dynamicLabel) {
          fetchedData = await getDataFromCube(filter?.member, filter?.dataSetType, filters, "filterDynamicLabel", filter?.dynamicLabel);
        } else {
          fetchedData = await getDataFromCube(filter?.member, filter?.dataSetType, filters);
        }
        if (fetchedData !== null) {
          setOptionsState((state) => ({ ...state, options: fetchedData }));
        }
      }
    } catch (error) {
      setOptionsState((state) => ({ ...state, error: error.message }))
    } finally {
      setOptionsState((state) => ({ ...state, loading: false }))
    }

  }

  return [optionsState, setOptionsState];
}

const useSearchOptionsState = ({ filter, optionsState }) => {
  const [searchOptionsState, setSearchOptionsState] = useState({
    options: [],
    loading: false,
    error: null,
    seachText: ''
  })
  const { filterState } = useReportFilters();
  const handleFilterSearchInput = async (event) => {
    try {
      event.stopPropagation();
      const value = event?.target?.value
      setSearchOptionsState((state) => ({ ...state, loading: true, seachText: value }))
      if (value === "") {
        setSearchOptionsState((state) => ({ ...state, options: [], loading: false }))
        return
      }
      let filterQuery = [{
        member: filter?.member,
        operator: 'contains',
        values: [value]
      }]
      let query = {}
      if (filter?.dataSetType === 'MEASURE') {
        query['measures'] = [filter?.member]
      }
      if (filter?.dataSetType === "DIMENSION") {
        query['dimensions'] = [filter?.member]
      }
      query.filters = filterQuery;
      let filters = filterState?.filters?.filter(_filter => _filter?.member === filter?.relevantTo);
      filters = filters?.map(_filter => {
        return {
          member: _filter?.member,
          operator: 'equals',
          values: _filter?.values
        }
      });
      if (filters?.length > 0) {
        query.filters = [...query.filters, ...filters]
      }
      const searchValues = await getDataFromCube(null, null, null, "custom_query_data", query)
      const options = searchValues?.map(item => item[filter?.member]);
      setSearchOptionsState((state) => ({ ...state, options }))
    } catch (error) {
      setSearchOptionsState((state) => ({ ...state, error: error.message }))
    } finally {
      setSearchOptionsState((state) => ({ ...state, loading: false }))
    }
  };

  const debouncedFetchFilterOptions = _.debounce((event) => {
    if (optionsState.options.length)
      handleFilterSearchInput(event);
  }, 1000);

  return [searchOptionsState, debouncedFetchFilterOptions];
}

export default function (props) {
  return (
    <ReportFilterProvider report={props.report} reportIndex={props.reportIndex} updateReport={props.updateReport} selectedReports={props.selectedReports} reportsTabsView={props.reportsTabsView}>
      <ReportFilterMenu {...props} />
    </ReportFilterProvider>
  )
}

const ReportFilterContext = createContext();

function ReportFilterProvider({ children, report, updateReport = () => { }, reportIndex, selectedReports, reportsTabsView }) {
  const { measureListByDataset, fetchMeasureListByDatasetId } = useMeasureListContext();
  const [filterState, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'SET_FILTERS':
          //console.log(state,action.payload)
          return {
            ...state,
            filters: action.payload.filters
          }

        case 'CLEAR_FILTER':
          const { filterIndex } = action.payload;
          if (state.filters[filterIndex])
            state.filters[filterIndex].values = [];
          if (state.filters[filterIndex]?.dateFilterProps?.dateSelectType === "TIME_PERIOD") {
            state.filters[filterIndex].dateFilterProps.selectedTimePeriod = '';
          }
          return {
            ...state
          }

        default:
          break;
      }
    },
    {
      loading: true,
      filters: []
    },
  );
  
  async function getFilters(report) {
    //console.log('Get Filters')
    if (!report) return [];
    if (!report.reportFilters?.length) return [];
    const clonedReport = structuredClone(report);

    return await clonedReport.reportFilters.filter(obj => obj.listType).map((filter, filterIndex) => {
      let isCascadedHidden = false;

      const selectedTabIndex = reportsTabsView?.[report._id] ?? 0;

      if(selectedTabIndex>0){
        const linkedReport = report.linkedReports[selectedTabIndex-1];
        if(linkedReport){
          const linkedFilter = linkedReport.reportId.reportFilters.find(f => 
            f.member.split('.')[1] === filter.member.split('.')[1] && 
            f.operator === filter.operator
          );
          if(linkedFilter){
            filter.values = linkedFilter.values;
          }
          else{
            filter.values = [];
          }
        }
      }

      if (filter.hidden) {
        isCascadedHidden = true;
      }
      if (filter.relevantTo) {
        const parentFilter = report.reportFilters.find(f => f.listType && f.member === filter.relevantTo);
        //console.log(parentFilter)
        if (parentFilter && parentFilter.hidden || parentFilter.values.length === 0) {
          isCascadedHidden = true;
        }
      }
      return {
        ...filter,
        filterIndex,
        isCascadedHidden
      }
    }).filter(filter => {
      if (filter.sheetFilter == true || filter.listType == undefined) {
        return false
      }
      return true
    })
  }

  async function filtersChange() {
    const filters = await getFilters(report);
    //console.log(filters)
    if (dispatch)
      dispatch({
        type: 'SET_FILTERS',
        payload: { filters }
      })
  }

  useEffect(() => {
    if (!report) return;
    filtersChange();
  }, [report])

  function removeCascadedFilterValues({ reportFilter, reportFilters, mainReport, report }) {
    try {
      //console.log(reportFilter)
      const mainReportFilters = mainReport.reportFilters;
      let _reportFilters = structuredClone(reportFilters);
      if (reportFilter?.useRelevant?.length !== 0) {
        const filterIndex = reportFilters.findIndex((obj) => obj.listType === reportFilter.listType && obj.member === reportFilter?.member && obj.operator === reportFilter?.operator);
        if (filterIndex === -1) return reportFilter;

        _reportFilters[filterIndex] = reportFilter;
        // update in linked reports
        report.linkedReports?.forEach((linkedReport, linkedReportIndex) => {
          const linkedReportFilterIndex = linkedReport.reportId.reportFilters.findIndex(f => f.member.split('.')[1] === reportFilter.member.split('.')[1] && f.operator === reportFilter.operator);
          if (linkedReportFilterIndex > -1) {
            linkedReport.reportId.reportFilters[linkedReportFilterIndex].values = mainReport?.reportId?.linkedReports?.[linkedReportIndex]?.reportFilters?.[linkedReportFilterIndex]?.values ?? [];
          }
        });

        reportFilter?.useRelevant?.forEach(cascadeFilterRelevant => {
          const cascadeFilterIndex = _reportFilters.findIndex((obj) => obj.listType && obj.member === cascadeFilterRelevant.relevantMember);
          if (cascadeFilterIndex === -1) return;

          _reportFilters[cascadeFilterIndex].values = mainReportFilters?.[cascadeFilterIndex].values ?? [];
          // update in linked reports
          /* report.linkedReports?.forEach((linkedReport, linkedReportIndex) => {
            const linkedReportFilterIndex = linkedReport.reportId.reportFilters.findIndex(f => f.member.split('.')[1] === _reportFilters[cascadeFilterIndex].member.split('.')[1] && f.operator === _reportFilters[cascadeFilterIndex].operator);
            if (linkedReportFilterIndex > -1) {
              linkedReport.reportId.reportFilters[linkedReportFilterIndex].values = mainReport?.reportId?.linkedReports?.[linkedReportIndex]?.reportFilters?.[linkedReportFilterIndex]?.values ?? [];
            }
          }); */

          if (_reportFilters[cascadeFilterIndex]?.useRelevant?.length === 0) return;

          _reportFilters = removeCascadedFilterValues({ reportFilter: _reportFilters[cascadeFilterIndex], reportFilters: _reportFilters, mainReport, report })
        });
      }
      return _reportFilters;
    } catch (error) {
      console.log('removeCascadedFilterValues error : ', error);
      return reportFilters;
    }
  }

  async function clearFilter(filterIndex) {
    const filters = [...filterState.filters];
    const filter = filters[filterIndex]
    const mainReport = await selectedReports.find(({ reportId }) => reportId === report.reportId);
    
    let reportFilters = await structuredClone(report.reportFilters);
    //const mainReportFilters = mainReport.reportFilters;
    let filterObj = report.reportFilters.find(obj => (obj.operator === filter.operator && obj.member === filter.member && obj.listType === filter.listType))
    let mainReportFilterObj = mainReport.reportFilters.find(obj => (obj.operator === filter.operator && obj.member === filter.member && obj.listType === filter.listType))
    //console.log(filterObj)
    if (filterObj.values.length > 0) {
      if (filterObj.useRelevant.length === 0) {

        filterObj.values = mainReportFilterObj.values ?? [];
        if (filterObj?.dateFilterProps?.dateSelectType === "TIME_PERIOD" && filterObj.values.length === 0) {
          filterObj.dateFilterProps.selectedTimePeriod = '';
        }
        //report.reportFilters = reportFilters;
        report.reportFilters.map(obj => {
          if(obj.operator === filter.operator && obj.member === filter.member && obj.listType === filter.listType){
            return filterObj
          }
          return obj
        })
        // linked reports
        await report.linkedReports.forEach((linkedReport, linkedReportIndex) => {
          const linkedReportFilterIndex = linkedReport.reportId.reportFilters.findIndex(f => f.member.split('.')[1] === filterObj.member.split('.')[1] && f.operator === filterObj.operator);
          if (linkedReportFilterIndex > -1) {
            linkedReport.reportId.reportFilters[linkedReportFilterIndex].values = mainReport?.reportId?.linkedReports?.[linkedReportIndex]?.reportFilters?.[linkedReportFilterIndex]?.values ?? [];
          }
        });
        updateReport(report, reportIndex);
        dispatch({
          type: 'CLEAR_FILTER',
          payload: {
            filterIndex
          }
        })
        return
      }
      if (filterObj?.dateFilterProps?.dateSelectType === "TIME_PERIOD" && (mainReportFilterObj?.values ?? []).length === 0) {
        filterObj.dateFilterProps.selectedTimePeriod = '';
      }
      reportFilters = await removeCascadedFilterValues({ reportFilter: { ...filterObj, values: mainReportFilterObj?.values ?? [] }, reportFilters, mainReport, report });
      report.reportFilters = reportFilters;
      updateReport(report, reportIndex);
    }
    dispatch({
      type: 'CLEAR_FILTER',
      payload: {
        filterIndex
      }
    })
  }

  async function updateFilter({ filterIndex, values, filter }) {
    const filters = [...filterState.filters];
    //console.log(filters)
    if (filter) {
      filters[filterIndex] = { ...filter };
      //console.log(filters)
      dispatch({
        type: 'SET_FILTERS',
        payload: {
          filters
        }
      })
      return
    }

    if (filters[filterIndex]) {
      filters[filterIndex].values = values;
      dispatch({
        type: 'SET_FILTERS',
        payload: {
          filters
        }
      })
    }
  }

  async function applyFilter(filter) {
    //console.log(filter,filterState.filters)
    const reportFilter = structuredClone(filterState.filters[filter.filterIndex]);
    //console.log(reportFilter)
    delete reportFilter.filterIndex;
    delete reportFilter.isCascadedHidden;
    const selectedTabIndex = reportsTabsView?.[report._id] ?? 0;
    if (selectedTabIndex === 0) {
    report.reportFilters.map(obj => {
      if(obj.operator === filter.operator && obj.member === filter.member && obj.listType === filter.listType){
        obj.values = [...reportFilter.values]
        obj.dateFilterProps = {...reportFilter.dateFilterProps}
        //return { ...reportFilter, values: [...reportFilter.values] }
      }
      return obj
    })
    }
    else {
      const linkedReport = report.linkedReports[selectedTabIndex - 1]
      if (linkedReport) {
        const linkedReportFilterIndex = linkedReport.reportId.reportFilters.findIndex(f => f.member.split('.')[1] === reportFilter.member.split('.')[1] && f.operator === reportFilter.operator);
        if (linkedReportFilterIndex > -1) {
          /* let values = [];
          if (linkedReport.reportId.reportFilters[linkedReportFilterIndex].listType === 'multiSelect') {
            values = reportFilter.values;
          } */
          linkedReport.reportId.reportFilters[linkedReportFilterIndex].values = [...new Set([...reportFilter.values])];
        }
        else {
        const dataSetId = linkedReport.reportId.dataSetId;
        const measureList = measureListByDataset[dataSetId] || await fetchMeasureListByDatasetId(dataSetId);
        const measureExist = await measureList?.find((measure) => measure?.name === reportFilter?.member?.split('.')[1]);
          if (measureExist) {
        const dataSetName = linkedReport?.reportId?.dataSetId?.dataSetName || linkedReport?.reportId?.measures?.[0]?.fieldName?.split('.')[0] || linkedReport?.reportId?.dimensions?.[0]?.fieldName?.split('.')[0];
        linkedReport.reportId.reportFilters.push({
          member: `${dataSetName}.${reportFilter?.member?.split('.')[1]}`,
          operator: reportFilter?.operator,
          values: reportFilter?.values,
          linkedReportFilter: true
        })
          }
        }
      }
    }
    updateReport(report, reportIndex);
  }

  return (
    <ReportFilterContext.Provider value={{ clearFilter, filterState, updateFilter, applyFilter }}>
      {children}
    </ReportFilterContext.Provider>
  )
}

function useReportFilters() {
  const context = useContext(ReportFilterContext);
  if (context === undefined) {
    throw new Error(
      `useReportFilters must be used within a ReportFilterProvider`
    );
  }
  return context;
} 